module.exports = {"211303001":"向阳街道","211303002":"燕山街道","211303003":"马山街道","211303004":"新华街道","211303005":"海龙街道","211303070":"开发区龙泉街道","211303101":"七道泉子镇","211303102":"西大营子镇","211303103":"召都巴镇","211303105":"大平房镇","211303106":"联合镇","211303107":"边杖子镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/211303.json
// module id = 591
// module chunks = 0